import { render, staticRenderFns } from "./editDocumentDialog.vue?vue&type=template&id=5dddccf5&lang=pug"
import script from "./editDocumentDialog.vue?vue&type=script&lang=js"
export * from "./editDocumentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports